<template>
  <b-form-group
    label="Birim Maliyet"
    label-for="unit_cost"
  >
    <validation-provider
      #default="{ errors }"
      name="Birim Maliyet"
      rules="required"
    >
      <cleave
        id="unit_cost"
        v-model="dataItem.unit_cost"
        class="form-control"
        :raw="true"
        :options="options.number"
        placeholder="Birim Maliyet"
      />
      <small
        v-if="!errors[0]"
        class="text-muted"
      >(KDV Hariç Tutar)</small>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'
import {
  BFormGroup,
} from 'bootstrap-vue'

export default {
  name: 'UnitCost',
  components: {
    Cleave,
    ValidationProvider,
    BFormGroup,
  },
  data() {
    return {
      required,
      options: {
        number: {
          numeral: true,
        },
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['productPrices/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
